<template>
    <div v-if="value && value.pendentes && value.pendentes.length">
        <table class="table table-sm mb-0 table-danger small my-1">
            <thead>
                <tr>
                    <th>
                        <a href="#" @click.prevent="detalhes = !detalhes" class="card-link">
                            Valores Pendentes de Pagamento
                        </a>
                    </th>
                    <th class="text-right">
                        <a href="#" @click.prevent="abrir_pagamentos()" class="card-link">
                            <i class="fa fa-eye mr-3" aria-hidden="true"></i>
                        </a>
                        {{ $util.formatMoeda(total_pendente(value.pendentes, false)) }}
                    </th>
                </tr>
            </thead>
            <tbody v-if="detalhes">
                <tr v-for="(pendente, ipx) in value.pendentes" :key="ipx">
                    <td>
                        <a href="#" @click.prevent="abrir_atendimento(pendente.id_atendimento)" class="card-link">
                            #{{ pendente.id_atendimento }}
                        </a>
                    </td>
                    <td class="text-right">{{ $util.formatMoeda(total_pendente(pendente)) }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import $ from 'jquery';

export default {
    data() { 
        return { 
            detalhes: false, 
        };
    },

    props: ['value'],

    methods: { 
        abrir_pagamentos () { 
            $('.modal').modal('hide');

            const id = this.value.id_pessoa 
                ? this.value.id_pessoa 
                : ( this.value.id_paciente ? this.value.id_paciente : '' );

            this.$router.push({ path: '/recepcao/pagamentos/' + id });
        },

        abrir_atendimento (id) { 
            $('.modal').modal('hide');

            if ( this.$route.path == '/recepcao') { 
                this.$router.push({ path: '/' })
                    .then(() => { 
                        this.$util.abrir_atendimento(this, id);
                    });
            } else { 
                this.$util.abrir_atendimento(this, id);
            }
        },

        total_pendente(lista, item = true) { 
            if ( !item ) { 
                lista = lista.flatMap(pag => pag.item_pagamento_atendimentos);
            } else { 
                lista = lista.item_pagamento_atendimentos;
            }

            return lista.reduce((total, carry) => { 
                return total + carry.dc_valor; 
            }, 0);
        },
    }
}
</script>